module.exports = __webpack_public_path__ + "static/media/1_CN.a647aa9e.png";